import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import { CreateHouseholdModel } from '@models/create-household.model';
import { Household } from '@models/foyers/household.model';
import { Guest } from '@models/foyers/guest.model';
import { ReorderHouseholdModel } from '@models/foyers/reorder-household.model';
import { ResponseModel } from '@models/response.model';
import { PaginationModel } from '@models/shared/pagination.model';

@Injectable({
  providedIn: 'root',
})
export class HouseholdService {
  private readonly householdsApi = `${environment.portageUrl}/households`;
  private httpService = inject(HttpService);

  listHousehold(page: number = 1): Observable<PaginationModel<Household>> {
    return this.httpService.get(`${this.householdsApi}`, { page });
  }

  searchHousehold(payload: {
    q: string;
    diets: number[];
    communes: number[];
    delivery_rounds: number[];
    page: number;
  }): Observable<PaginationModel<Household>> {
    return this.httpService.post(`${this.householdsApi}/search`, payload);
  }

  getHousehold(id: number): Observable<Household> {
    return this.httpService.get(`${this.householdsApi}/${id}`);
  }

  createHousehold(
    createHousehold: Partial<CreateHouseholdModel>
  ): Observable<any> {
    return this.httpService.post(`${this.householdsApi}`, createHousehold);
  }

  listHouseholdGuests(id: number): Observable<Guest[]> {
    return this.httpService.get(`${this.householdsApi}/${id}/guests`);
  }

  reorder(payload: ReorderHouseholdModel): Observable<ResponseModel> {
    return this.httpService.patch(`${this.householdsApi}/reorder`, payload);
  }

  updateHousehold(
    id: number,
    payload: Partial<CreateHouseholdModel>
  ): Observable<{ message: string }> {
    payload.id = id;
    return this.httpService.put(`${this.householdsApi}`, payload);
  }

  deleteHousehold(
    id: number
  ): Observable<ResponseModel> {
    return this.httpService.delete(`${this.householdsApi}/${id}`);
  }
}
